const URL =
  window.location.href.indexOf('localhost') !== -1
    ? 'http://localhost:3000/api/'
    : `${window.location.origin}/api/`;

const queryString = require('query-string');

const API = {
  get headers() {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
  },

  call(endpoint, method = 'GET', data = null) {
    let fetchOpt = {
      method: method,
      headers: API.headers,
    };

    if (method !== 'GET' && data) {
      fetchOpt.body = JSON.stringify(data);
    }

    if (method === 'GET' && data) {
      endpoint += '?' + queryString.stringify(data);
    }

    return fetch(URL + endpoint, fetchOpt);
  },
};

export default API;



// WEBPACK FOOTER //
// ./src/services/api.js